import { render, staticRenderFns } from "./CreateCopyButton.vue?vue&type=template&id=298b0fce&scoped=true"
import script from "./CreateCopyButton.vue?vue&type=script&lang=js"
export * from "./CreateCopyButton.vue?vue&type=script&lang=js"
import style0 from "./CreateCopyButton.vue?vue&type=style&index=0&id=298b0fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b0fce",
  null
  
)

export default component.exports